import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {maps as gmaps} from 'google';
import {connect} from 'react-redux';
import compose from 'recompose/compose';

import PoweredByGoogle from '@spothero/ui/powered-by-google';
import GooglePlacesSearchInput from '@spothero/ui/google-places-search-input';
import WithConfig from 'config/WithConfig';

class PlaceSearch extends Component {
    constructor(props) {
        super(props);

        const {
            searchBounds,
        } = props;

        this._bounds = (searchBounds.sw_lat)
            ? new gmaps.LatLngBounds(
                new gmaps.LatLng(searchBounds.sw_lat, searchBounds.sw_lng),
                new gmaps.LatLng(searchBounds.ne_lat, searchBounds.ne_lng)
            )
            : null;
    }

    render() {
        const {
            className,
            cloudinary,
            defaultValue,
            onChange,
            onClear,
            onSelect,
            placeholder,
            ...props
        } = this.props;
        const classes = classnames('PlaceSearch', className);

        return (
            <GooglePlacesSearchInput
                {...props}
                bounds={this._bounds}
                className={classes}
                defaultValue={defaultValue}
                googleMaps={gmaps}
                onChange={onChange}
                onClear={onClear}
                onSuggestionSelect={onSelect}
                placeholder={placeholder}
                poweredByGoogleFooter={<PoweredByGoogle cloudinary={cloudinary} />}
            />
        );
    }
}

PlaceSearch.propTypes = {
    className: PropTypes.string,
    cloudinary: PropTypes.object.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onSelect: PropTypes.func,
    placeholder: PropTypes.string,
    searchBounds: PropTypes.shape({
        sw_lat: PropTypes.number, // eslint-disable-line camelcase
        sw_lng: PropTypes.number, // eslint-disable-line camelcase
        ne_lat: PropTypes.number, // eslint-disable-line camelcase
        ne_lng: PropTypes.number, // eslint-disable-line camelcase
    }),
};

const mapStateToProps = state => {
    const {
        city: {
            data: {
                search_bounds: searchBounds,
            } = {}
        } = {}
    } = state;

    return {
        searchBounds,
    };
};

const enhance = compose(
    WithConfig,
    connect(mapStateToProps)
);

export default enhance(PlaceSearch);
